import {Component, OnInit} from '@angular/core';
import {filter, map} from 'rxjs/operators';
import {of} from 'rxjs';

@Component({
    selector: 'app-experiment',
    templateUrl: './experiment.component.html',
    styleUrls: ['./experiment.component.css']
})
export class ExperimentComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {
        const month_names1 = [{month: 'Jan', id: 1}, {month: 'Feb', id: 1}, {month: 'Mar', id: 1}];
        // const abcd = month_names1.reverse();
        month_names1.push({month: 'Aprsl', id: 1}, {month: 'May', id: 1});
        month_names1.pop();
        month_names1.unshift({month: 'JanFirst', id: 1}, {month: 'JanSecond', id: 1});
        month_names1.splice(1, 2);
        month_names1.forEach((item, index) => {
            console.log(item); // 1, 2, 3
            console.log(index); // 0, 1, 2
        });
        month_names1[0].month.substring(1, 3);
        month_names1.map((item, index) => {
            console.log(item); // 1, 2, 3
            console.log(index); // 0, 1, 2
        });

        // first filter the no. into prime no then map will factorial the remaining number
        const squareOf2 = of(1, 2, 3, 4, 5, 6)
            .pipe(
                filter(num => num % 2 === 0),
                map(num => num * num)
            );
        squareOf2.subscribe((num) => console.log(num));  // 4 , 16 ,36

        // generic methods
        const myNumArr1 = this.getArray<number>([100, 200, 300]);
        const myStrArr2 = this.getArray<string>(['Hello', 'World']);

        // Tuple - that will allow more than two data types in a single varible
        const employee: [number, string] = [1, 'Steve'];

        // Union - that will allow two data type in a single variable
        let code: (string | number);
        code = 123;   // OK
        code = 'ABC'; // OK
        // code = false; // Compiler Error

        // Function Overloading
        this.add('Hello ', 'Steve'); // returns "Hello Steve"
        this.add(1, 2); // returns 30

        const arr = [10, 20, 30, 40];

        // for loop difference
        for (const index in arr) {
            console.log(index); // prints indexes: 0, 1, 2, 3

            console.log(arr[index]); // prints elements: 10, 20, 30, 40
        }
        for (const index1 of arr) {
            console.log(index1); // prints indexes: 10, 20, 30, 40
        }
    }

    add(a: string, b: string): string;

    add(a: number, b: number): number;

    add(a: any, b: any): any {
        return a + b;
    }

    getArray<T>(items: T[]): T[] {
        return new Array<T>().concat(items);
    }
}
// extension method for string and numbers
declare global {
    interface String {
        toAddPrefix(prefix: string): string;
    }

    interface Number {
        toSum(a: number, b: number): number;
    }
}

String.prototype.toAddPrefix = function (prefixStr: string) {
    return `${prefixStr}${this}`;
};
Number.prototype.toSum = function (a: number, b: number) {
    return a + b;
};

// end of extension methods

class Circle {
    static pi = 3.14;

    static calculateArea(radius: number) {
        return this.pi * radius * radius;
    }

    calculateCircumference(radius: number): number {
        return 2 * Circle.pi * radius;
    }
}

// static method
Circle.calculateArea(5); // returns 78.5

// non-static method
const circleObj = new Circle();
circleObj.calculateCircumference(5); // returns 31.4000000